































import Vue, { PropType } from "vue";
import draggable from "vuedraggable";
import DraggableTreeViewNode from "./DraggableTreeviewNode.vue";
export default Vue.extend({
    components: {
        draggable,
        DraggableTreeViewNode,
    },
    props: {
        value: {
            type: Number,
            default: null,
        },
        items: {
            type: Array,
            default: (): { id: string | number }[] => {
                return [];
            },
        },
        group: {
            type: String,
            default: null,
        },
        expandIcon: {
            type: String,
            default: "mdi-menu-down",
        },
        activatable: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        themeClassName(): string {
            return (this as any).$vuetify.theme.dark ? "theme--dark" : "theme--light";
        },
        localItems: {
            get() {
                return (this as any).items;
            },
            set(newValue) {
                (this as any).$emit("update", newValue);
            }
        }
    },
    watch: {
        items(value) {
        },
    },
    methods: {
        updateValue(value): void {
            (this as any).localItems = value;
            this.$emit("update", value);
        },
        updateItem(itemValue): void {
            const index = (this as any).localItems.findIndex((v) => v.id === itemValue.id);
            this.$set((this as any).localItems, index, itemValue);
            this.$emit("update");
        },
        updateActive(value): void {
            this.$emit("input", ((this as any).returnObject ? value.id : value));
            this.$emit("updateActive", [value]);
        },
    },
});
